import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { useEffect, useState } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useLazyGetCustomerByIdQuery } from "../../services/customer";
import { showError } from "../../constants/toasts";
import { SubAdmin, SubAdminResponse } from "../../types/General";
import moment from "moment";
import { IconButton } from "@mui/material";
import { ROLES } from "../../utils/enums";
import useAuth from "../../hooks/useAuth";

const SubadminDetail = () => {

  const navigate = useNavigate();
  const params = useParams()
  const id = params.id as string
  const user = useAuth()
  const [loading, setLoading] = useState(false);
  const [subAdmin,setSubAdmin] = useState<SubAdminResponse>()
  const [getCustomerById] = useLazyGetCustomerByIdQuery();

  const getSubAdminById = async () => {
    setLoading(true);
    try {
      const response = await getCustomerById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        // setCustomerDetail(response?.data || null);
        setSubAdmin(response?.data)
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

 

  useEffect(()=>{
    if(user?.role===ROLES.SUB_ADMIN){
      navigate('/permission-denied',{replace:true})
    }
  },[user])

  useEffect(()=>{
    if(id) getSubAdminById()
  },[id])

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - Sub-Admin Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          {subAdmin?.image?<div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={`${subAdmin?.image?subAdmin?.image:'/static/images/user_placeholder.png'}`} />
            </figure>
          </div>:null}
          <div className="w_33">
            <h6>Name</h6>
            <p>{subAdmin?.fullName || ""}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{subAdmin?.email || ""}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{subAdmin?.countryCode }{ subAdmin?.phone}</p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>{subAdmin?.accessRole?.name}{<IconButton onClick={()=>navigate(`/manage-subadmin/roles/detail/${subAdmin?.accessRole?._id}`)}>
              <OpenInNewIcon  fontSize="small"/>
              </IconButton>}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{moment(subAdmin?.createdAt).format('YYYY-MM-DD')}</p>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default SubadminDetail;
